document.addEventListener("DOMContentLoaded", function () {
    const form = document.querySelector(".conditional-contact-form form");
    if (!form) return;
  
    form.querySelectorAll("input, select, textarea").forEach((input) => {
      if (input.hasAttribute("required") || input.getAttribute("aria-required") === "true") {
        input.dataset.required = "true";
      }
    });
  
    function toggleConditionalFields() {
      const conditionalFields = form.querySelectorAll("[data-show-when]");
  
      conditionalFields.forEach((field) => {
        const controllingFieldIds = field.dataset.showWhen
          .split("|")
          .map((id) => id.trim());
        const requiredValues = field.dataset.showWhenValue
          .split("|")
          .map((v) => v.trim());
        let shouldShow = false;
  
        controllingFieldIds.forEach((controllingFieldId) => {
          const controllingContainer = form.querySelector(
            `[data-field-id="${controllingFieldId}"]`
          );
          if (!controllingContainer) return;
  
          const controllingField = controllingContainer.querySelector(
            "input, select, textarea"
          );
          if (!controllingField) return;
  
          let currentValue = "";
  
          if (controllingField.type === "select-one") {
            currentValue = controllingField.value;
          } else if (controllingField.type === "radio") {
            const checkedRadio = form.querySelector(
              `input[name="${controllingField.name}"]:checked`
            );
            currentValue = checkedRadio ? checkedRadio.value : "";
          } else if (controllingField.type === "checkbox") {
            const checkboxes = form.querySelectorAll(
              `input[name="${controllingField.name}"]:checked`
            );
            const checkedValues = Array.from(checkboxes).map((cb) =>
              cb.value.trim()
            );
  
            if (
              checkedValues.some((val) =>
                requiredValues
                  .map((v) => v.toLowerCase())
                  .includes(val.toLowerCase())
              )
            ) {
              shouldShow = true;
            }
            return;
          } else {
            currentValue = controllingField.value;
          }
  
          if (
            requiredValues
              .map((v) => v.toLowerCase())
              .includes(currentValue.trim().toLowerCase())
          ) {
            shouldShow = true;
          }
        });
  
        if (shouldShow) {
          field.classList.add("field-visible");
          field.style.display = "flex";
        
          field.querySelectorAll("input, select, textarea").forEach((input) => {
            input.disabled = false;
            if (input.dataset.required === "true") {
              input.setAttribute("required", "required");
            }
          });
        } else {
          field.classList.remove("field-visible");
          field.style.display = "none";
        
          field.querySelectorAll("input, select, textarea").forEach((input) => {
            input.disabled = true;
            input.removeAttribute("required");
  
            if (input.type === "checkbox" || input.type === "radio") {
              input.checked = false;
            } else if (
              input.type !== "hidden" &&
              input.name !== "h-captcha-response"
            ) {
              input.value = "";
            }
          });
        }
      });
    }
  
    form.addEventListener("change", toggleConditionalFields);
    form.addEventListener("input", toggleConditionalFields);
    form.addEventListener("click", toggleConditionalFields);
  
    setTimeout(toggleConditionalFields, 100);
  
    form.addEventListener("submit", function (e) {
      // Prevent default submission first
      e.preventDefault();
    
      // Disable empty visible fields
      const visibleFields = form.querySelectorAll(
        ".contact-form__field.field-visible input, .contact-form__field.field-visible textarea, .contact-form__field.field-visible select"
      );
    
      visibleFields.forEach((input) => {
        if (input.type === "hidden") return;
        if (input.name === "h-captcha-response") return;
    
        if (!input.value.trim()) {
          input.disabled = true;
        }
      });
    
      // Disable hidden empty fields (iOS fix)
      const hiddenFields = form.querySelectorAll(
        ".contact-form__field:not(.field-visible) input, .contact-form__field:not(.field-visible) textarea, .contact-form__field:not(.field-visible) select"
      );
    
      hiddenFields.forEach((input) => {
        if (input.type === "hidden") return;
        if (input.name === "h-captcha-response") return;
    
        input.removeAttribute("required");
        if (!input.value.trim()) input.disabled = true;
      });
    
      // Submit the form programmatically after fields cleaned
      form.submit();
    });
  
    // Prefill from URL
    const urlParams = new URLSearchParams(window.location.search);
  
    function normalise(str) {
      return str?.trim().toLowerCase();
    }
  
    urlParams.forEach((paramValue, paramKey) => {
      const paramNormalised = normalise(paramValue);
  
      let labels;
  
      if (typeof labelMap !== "undefined" && labelMap[paramKey]) {
        const mappedLabels = labelMap[paramKey];
        labels = Array.isArray(mappedLabels) ? mappedLabels : [mappedLabels];
      } else {
        labels = [paramKey];
      }
  
      labels.forEach((label) => {
        const allFields = document.querySelectorAll("[data-field-id]");
  
        allFields.forEach((container) => {
          const fieldLabel = container.getAttribute("data-field-id");
          if (normalise(fieldLabel) !== normalise(label)) return;
  
          const dropdown = container.querySelector("select");
          if (!dropdown) return;
  
          for (let i = 0; i < dropdown.options.length; i++) {
            const option = dropdown.options[i];
            if (normalise(option.value) === paramNormalised) {
              dropdown.selectedIndex = i;
              dropdown.dispatchEvent(new Event("change"));
              break;
            }
          }
        });
      });
    });
  });